import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Box, Button, Drawer, Hidden, List } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { NavItem } from "./NavItem";
import { useNavBarStyles } from "./styles";
import { useMaster } from "../Provider/Master";
export const NavBar = ({ onClose, open, routes, desktopStartsOpen = true, }) => {
    const { logout } = useMaster();
    const classes = useNavBarStyles();
    const location = useLocation();
    React.useEffect(() => {
        if (open && onClose) {
            onClose();
        }
    }, [location.pathname]);
    const content = (_jsxs(Box, Object.assign({ height: "100%", display: "flex", flexDirection: "column" }, { children: [_jsx(Box, Object.assign({ p: 2 }, { children: _jsx(List, { children: routes.map((route, key) => (_jsx(NavItem, { route: route }, key))) }, void 0) }), void 0),
            _jsx(Box, { flexGrow: 1 }, void 0),
            _jsx(Box, Object.assign({ p: 2, m: 2 }, { children: _jsx(Button, Object.assign({ fullWidth: true, variant: "contained", color: "secondary", onClick: () => logout() }, { children: "D\u00E9connection" }), void 0) }), void 0)] }), void 0));
    return (_jsxs(_Fragment, { children: [_jsx(Hidden, Object.assign({ lgUp: true }, { children: _jsx(Drawer, Object.assign({ anchor: "left", classes: { paper: classes.mobileDrawer }, onClose: onClose, open: open, variant: "temporary" }, { children: content }), void 0) }), void 0),
            _jsx(Hidden, Object.assign({ mdDown: true }, { children: _jsx(Drawer, Object.assign({ anchor: "left", classes: { paper: classes.desktopDrawer }, open: desktopStartsOpen ? !open : open, variant: "persistent" }, { children: content }), void 0) }), void 0)] }, void 0));
};
//# sourceMappingURL=index.js.map